import React, { useState } from 'react'
import styles from './styles.module.css'

function WebsiteExpandedRecord({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  // Limit the display of websites to 5 unless expanded
  const websitesToShow = isExpanded
    ? record.websites
    : record.websites?.slice(0, 5) || []

  return (
    <div className={styles.WebsiteExpandedRecordContainer}>
      <span className={styles.WebsiteExpandedRecordTitle}>Websites</span>

      <div className={styles.WebsiteExpandedRecordList}>
        {websitesToShow.length > 0 ? (
          websitesToShow.map((website, index) => (
            <a
              key={index}
              href={website} // Navigate to the website URL
              target="_blank" // Open the link in a new tab
              rel="noopener noreferrer"
              className={styles.WebsiteExpandedRecordItem}
            >
              {website}
            </a>
          ))
        ) : (
          <span className={styles.NoWebsiteExpandedRecord}>N/A</span>
        )}
      </div>

      {/* Show the expand button only if there are more than 5 websites */}
      {record.websites && record.websites.length > 5 && (
        <button
          className={styles.WebsiteExpandedRecordButton}
          onClick={toggleExpand}
        >
          {isExpanded ? 'Show less' : `Expand all (${record.websites.length})`}
        </button>
      )}
    </div>
  )
}

export default WebsiteExpandedRecord
